module.exports = __webpack_public_path__ + "img/discord-circle-v2.9d558fb3.svg";